import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const Avatar = ({ src, name, small }) => {
    const renderPhoto = () => {
        if (src) {
            return <div className="avatar__photo">{<img src={src} alt={`Avatar about ${name}`} />}</div>;
        } else {
            return <div className="avatar__name">{name.trim().charAt(0).toUpperCase()}</div>;
        }
    };

    return <div className={clsx("avatar", { "avatar--small": small })}>{renderPhoto()}</div>;
};

Avatar.propTypes = {
    src: PropTypes.node,
    name: PropTypes.string,
    small: PropTypes.bool,
};

Avatar.defaultProps = {
    src: "",
    name: "",
    small: false,
};

export default Avatar;
